import { ContainerModule, interfaces } from 'inversify';
import { GetTeamMembersService, IGetTeamMembersService } from './services/getTeamMembers.service';
import { ITeamApiService, TeamApiService } from './services/teamApi.service';
import { ITeamService, TeamService } from './team.bl';
import { ITeamStore, TeamStore } from './team.store';

export const teamModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ITeamStore.$).to(TeamStore).inSingletonScope();
  bind(ITeamService.$).to(TeamService).inSingletonScope();
  bind(ITeamApiService.$).to(TeamApiService).inSingletonScope();
  bind(IGetTeamMembersService.$).to(GetTeamMembersService).inRequestScope();
});
